import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchRequest,
  setCurrentModal,
  updatePaginationRequest,
} from "../../../store/actions/alertsGroup";
import ActionMenu from "./ActionMenu";
import CustomModal from "../../../components/CustomModal";
import CustomUserList from "./CreateAlertGroup/CustomUserList";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import AlertGroupDetails from "./CreateAlertGroup/AlertGroupDetail";
import { Button } from "@vds/buttons";
import ToastNotification from "../../../global/components/ToastNotification";
import { setAlertGroupDetail, setActionType, deleteAlertGroupRequest, setNotification, exportAlertGroup } from "../../../store/actions/alertsGroup";
import { DropdownFilterWithSearch, DropdownFilterWithSearchAndCheckbox } from "../../../components/DropdownFilter";

const AlertsGroupList = () => {
  const dispatch = useDispatch();

  // Redux state selectors
  const isLoading = useSelector((state) => state.alertsGroup.isLoading);
  const user = useSelector((state) => state.auth.user);
  const [alertsGroupDataSource, setAlertsGroupDataSource] = useState([]);


  const [alertsGroupDetail, setAlertGroupDetails] = useState([]);
  const currentModal = useSelector(state => state.alertsGroup.currentModal)
  const [checkBox, setCheckbox] = useState(false);
  const alertGroupDetailGlobal = useSelector(state => state.alertsGroup.alertGroupDetail);
  const showNotification = useSelector(state => state.alertsGroup.notification);
  const filters = useSelector((state) => state.alertsGroup.filters);
  const totalCount = useSelector((state) => state.alertsGroup.alertGroupCount);
  const actionType = useSelector(state => state.alertsGroup.actionType);
   const [resetKey, setResetKey] = useState(0);

  const alertsGroup = useSelector((state) => {
    return state.alertsGroup
  });

  const viewAlertsGroup = (ele) => {
    dispatch(setActionType('View'))
    dispatch(setCurrentModal('ViewAlertGroupModal'));
    dispatch(setAlertGroupDetail({ alertGroupName: ele?.name, description: ele?.description, id: ele?.id, userList: ele?.users?.map(user => user.id) }))
    setAlertGroupDetails(ele)
  };

  const cloneAlertsGroup = (ele) => {
    dispatch(setActionType('Clone'))
    dispatch(setAlertGroupDetail({ alertGroupName: '', description: '', userList: ele?.users?.map(user => user.id) }))
    dispatch(setCurrentModal('EditAlertGroupModal'));
  };

  const editAlertsGroup = (ele) => {
    dispatch(setActionType('Edit'))
    dispatch(setAlertGroupDetail({ alertGroupName: ele?.name, description: ele?.description, id: ele?.id, userList: ele?.users?.map(user => user.id) }))
    dispatch(setCurrentModal('EditAlertGroupModal'));
  };

  const deleteAlertsGroup = (ele) => {
    dispatch(setActionType('Delete'))
    dispatch(setAlertGroupDetail({ alertGroupName: ele?.name, description: ele?.description, id: ele?.id, userList: ele?.users?.map(user => user.id) }))
    setAlertGroupDetails(ele);
    dispatch(setCurrentModal('DeleteAlertGroupModal'));
  };

  const exportAlertGroupFn = () => {
    dispatch(setActionType('Export'))
    dispatch(exportAlertGroup());
    dispatch(setNotification(null));
  }

  // useEffect(()=>{
  //   dispatch(fetchRequest());
  // },[showNotification])


  //current end

  //incoming
  const handleNameFilterChange = (val) => {
    let order = val.isAsc ? "asc" : "desc";
    let subjectFilter = "";
    if (val.filteredResult && val.filteredResult.length > 0) {
      subjectFilter = val.filteredResult;
    } else if (val.filters?.text) {
      subjectFilter = val.filters.text;
    }
    dispatch(
      fetchRequest({
        ...filters,
        sortOrder: order,
        name: subjectFilter,
        field: 'name'
      })
    );
  };

  const handleNameFilterReset = () => {
    dispatch(
      fetchRequest({
        ...filters,
        name: "",
        sort: null
      })
    );
  };

  const handleDescriptionFilterChange = (val) => {
    let order = val.isAsc ? "asc" : "desc";
    let subjectFilter = "";
    if (val.filteredResult && val.filteredResult.length > 0) {
      subjectFilter = val.filteredResult;
    } else if (val.filters?.text) {
      subjectFilter = val.filters.text;
    }
    dispatch(
      fetchRequest({
        ...filters,
        sortOrder: order,
        description: subjectFilter,
        field: 'description'
      })
    );
  };

  const handleDescriptionFilterReset = () => {
    dispatch(
      fetchRequest({
        ...filters,
        description: "",
        sort: null
      })
    );
  };

  const tableColumns = [{
    title: (
      <DropdownFilterWithSearch
        text="Name"
         accountId={user?.accountId}
        value={filters?.name}
        onApply={handleNameFilterChange}
        onReset={handleNameFilterReset}
        isSortable={true}
      />
    ),
    dataIndex: "name",
    key: "name",
    width: "31%",
    render: (text, record) => <button className="amt-btn-link" onClick={() => viewAlertsGroup(record)}>{text}</button>,
  }, {
    title: (
      <DropdownFilterWithSearch
      accountId={user?.accountId}
        text="Description"
        value={filters?.description}
        onApply={handleDescriptionFilterChange}
        onReset={handleDescriptionFilterReset}
        isSortable={true}
      />
    ),
    dataIndex: "description",
    key: "description",
    width: '31%',
    render: (text) => text,
  },
  { title: "Number of Users", dataIndex: "users_count", key: "users_count", width: '31%' },
  {
    title: <ActionMenu menuItems={[{ label: 'Export', handlerFunction: () => exportAlertGroupFn() }]} />,
    dataIndex: "action", key: "action", width: '7%'
  }]

  // incoming end


  // columns={[{title:"Name",dataIndex:"name",key:"name"},{title:"Description",dataIndex:"description",key:"description"}, {title:"Number of Users",dataIndex:"users_count",key:"users_count"}, {title: <ActionMenu menuItems={[{label:'Export',handlerFunction:()=>exportAlertGroupFn()}]} />,dataIndex:"action",key:"action"}]}


  useEffect(() => {
    const alertsGrouptmp = alertsGroup.data.alertsGroup.map(ele => {
      const menuItems = [];
      if (user?.role?.permissions?.alarms?.view) {
        menuItems.push({
          label: 'View alert group',
          handlerFunction: () => viewAlertsGroup(ele),
        })
      }
      if (user?.role?.permissions?.alarms?.edit) {
        menuItems.push({
          label: 'Edit alert group',
          handlerFunction: () => editAlertsGroup(ele),
        })
      }
      if (user?.role?.permissions?.alarms?.edit) {
        menuItems.push({
          label: 'Clone alert group',
          handlerFunction: () => cloneAlertsGroup(ele),
        })
      }
      if (user?.role?.permissions?.alarms?.delete) {
        menuItems.push({
          label: 'Delete alert group',
          handlerFunction: () => { deleteAlertsGroup(ele) }
        })
      }

      ele['action'] = <ActionMenu menuItems={menuItems} />
      return ele;
    });
    setAlertsGroupDataSource(alertsGrouptmp)
  }, [alertsGroup]);

  useEffect(() => {
    return () => dispatch(setNotification({}));
  }, [])

  const handleTableChange = (pagination) => {
    if (
      Object.hasOwn(pagination, "current") &&
      filters.pagenumber !== pagination.current - 1
    ) {
      dispatch(
        fetchRequest({ ...filters, pagenumber: pagination.current - 1 })
      );
    }
  };

  const handlePageSizeChange = (page, pageSize) => {
    dispatch(
      updatePaginationRequest({
        data: { pageSize: pageSize, currentPage: page },
        shouldUpdate: true,
      })
    );
     if(filters.limitnumber !== pageSize){
    dispatch(fetchRequest({ ...filters, limitnumber: pageSize, pagenumber: page - 1 }));
     }
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "12px",
      }}
    >
      {showNotification && (
        <ToastNotification
          type={showNotification.type}
          message={showNotification.message}
          description={showNotification.description}
          duration={showNotification.duration}
          style={showNotification.style}
        />
      )}
      <CustomModal popupName={actionType == 'Edit' ? 'Edit alert group' : 'Add alert group'} customClass={'viewAlertGroup'} popupTitle={'Alert group details'} open={currentModal == 'AlertGroupDetailModal'}>
        <AlertGroupDetails alertsGroupDetail={alertsGroupDetail} checkBox={checkBox} />
      </CustomModal>
      <CustomModal popupName={actionType == 'Edit' ? 'Edit alert group' : 'Add alert group'} customClass={'viewAlertGroup'} popupTitle={'Alert group details'} open={currentModal == 'EditAlertGroupModal'}>
        <AlertGroupDetails alertsGroupDetail={alertsGroupDetail} checkBox={checkBox} />
      </CustomModal>
      <CustomModal popupName={''} customClass={'deleteAlertGroup'} popupTitle={'Delete Alert Group'} open={currentModal == 'DeleteAlertGroupModal'}>

        <>
          <p style={{ padding: '5px', marginTop: '25px', paddingLeft: '0px' }}>Are you sure you want to delete alert group <strong>{alertsGroupDetail?.name}</strong></p>
          <Grid2
            container
            marginTop={1}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  shape="round"
                  style={{ fontWeight: "bold", width: "100%", backgroundColor: "white", color: "black", }}
                  onClick={() => dispatch(setCurrentModal(''))}
                  size={"large"}
                >
                  No, cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    dispatch(deleteAlertGroupRequest({ id: alertsGroupDetail?.id, name: alertsGroupDetail?.name }));
                    dispatch(fetchRequest());
                    dispatch(setNotification(null));
                    dispatch(setCurrentModal(''));
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Yes, delete
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </CustomModal>
      <CustomModal popupName={actionType == 'Edit' ? 'Edit alert group' : 'Add alert group'} customClass={'viewAlertGroup'} popupTitle={'Review alert group'} open={currentModal == 'ReviewAlertGroupDetailModal'}>
        <CustomUserList alertsGroupDetail={alertsGroupDetail} footerButtons={true}>
          <>
            <h2 className="font-face-vzb light-grey-text-color" style={{ fontSize: '20px', lineHeight: '24px' }}>Alert group details</h2>
            <Grid2
              container
              marginTop={1}
              marginBottom={0}
              spacing={1}
              columns={{ xs: 12 }}
            >
              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <h2 className="font-face-vzb" style={{ fontSize: '16px', lineHeight: '20px' }}>Alert Group Name</h2>
                  <p style={{ fontSize: '16px', lineHeight: '20px' }}>{alertGroupDetailGlobal.alertGroupName}</p>
                </div>
              </Grid2>

              <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                  <h2 className="font-face-vzb" style={{ fontSize: '16px', lineHeight: '20px' }}>Description</h2>
                  <p style={{ fontSize: '16px', lineHeight: '20px' }}>{alertGroupDetailGlobal.description}</p>
                </div>
              </Grid2>
            </Grid2>
            <h2 className="font-face-vzb light-grey-text-color" style={{ fontSize: '20px', lineHeight: '24px' }}>Users</h2>
          </>
        </CustomUserList>
      </CustomModal>
      <CustomModal popupName={actionType == 'Edit' ? 'Edit alert group' : 'Add alert group'} popupTitle={'Add Users'} customClass={'viewAlertGroup'} open={currentModal == 'EditUserListModal'}>
        <CustomUserList alertsGroupDetail={alertsGroupDetail} footerButtons={true}>
          {/* <>
        <h2 className="font-face-vzb light-grey-text-color" style={{fontSize:'20px', lineHeight:'24px'}}>Alert group details</h2>
        <Grid2
            container
            marginTop={1}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
        >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
                <div className="mb-3">
                    <h2 className="font-face-vzb" style={{fontSize:'16px', lineHeight:'20px'}}>Alert group name</h2>
                    <p  style={{fontSize:'16px', lineHeight:'20px'}}>{alertGroupDetailGlobal.alertGroupName}</p>
                </div>
            </Grid2>

            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                  <h2 className="font-face-vzb" style={{fontSize:'16px', lineHeight:'20px'}}>Description</h2>
                  <p  style={{fontSize:'16px', lineHeight:'20px'}}>{alertGroupDetailGlobal.description}</p>
              </div>
            </Grid2>
        </Grid2>
        <h2 className="font-face-vzb light-grey-text-color" style={{fontSize:'20px', lineHeight:'24px'}}>Add Users</h2>
        </> */}
        </CustomUserList>
      </CustomModal>
      {currentModal === 'ViewAlertGroupModal' && (
        <CustomModal
          popupName={''}
          popupTitle={alertGroupDetailGlobal?.alertGroupName}
          customClass={'viewAlertGroup'}
          open={true}
        >
          <CustomUserList alertsGroupDetail={alertsGroupDetail} footerButtons={true}>
            <>
              <h2 className="font-face-vzb light-grey-text-color" style={{ fontSize: '20px', lineHeight: '24px' }}>Alert group details</h2>
              <Grid2
                container
                marginTop={1}
                marginBottom={0}
                spacing={1}
                columns={{ xs: 12 }}
              >
                <Grid2 item xs={12} sm={6} md={6} lg={6}>
                  <div className="mb-3">
                    <h2 className="font-face-vzb" style={{ fontSize: '16px', lineHeight: '20px' }}>Alert Group Name</h2>
                    <p style={{ fontSize: '16px', lineHeight: '20px' }}>{alertGroupDetailGlobal?.alertGroupName}</p>
                  </div>
                </Grid2>
                <Grid2 item xs={12} sm={6} md={6} lg={6}>
                  <div className="mb-3">
                    <h2 className="font-face-vzb" style={{ fontSize: '16px', lineHeight: '20px' }}>Description</h2>
                    <p style={{ fontSize: '16px', lineHeight: '20px' }}>{alertGroupDetailGlobal?.description}</p>
                  </div>
                </Grid2>
              </Grid2>
              <h2 className="font-face-vzb light-grey-text-color" style={{ fontSize: '20px', lineHeight: '24px' }}>Users</h2>
            </>
          </CustomUserList>
        </CustomModal>
      )}
      <Table
        rowKey="key"
         resetKey={resetKey}
        loading={isLoading}
        columns={tableColumns}
        dataSource={alertsGroupDataSource}
        onChange={handleTableChange}
        style={{
          width: "100%",
          minWidth: "1200px",
          overflowX: "auto",
        }}
        // scroll={{ x: "max-content" }}
        className="alertsGroupList"
        pagination={
          {
            current: filters.pagenumber + 1,
            pageSize: filters.limitnumber,
            total: totalCount,
            showTotal: (total, range) =>
              `Showing ${range[0]}-${range[1]} of ${total}`,
            position: ["bottomRight"],
            prevIcon: ["Prev"],
            nextIcon: ["Next"],
            pageSizeOptions: [10, 20, 50, 100],
            onChange: (page, pageSize) => handlePageSizeChange(page, pageSize),
            showSizeChanger: true,
            locale: {
              items_per_page: "",
            }
          }
        }
      />
    </div>
  );
};

export default AlertsGroupList;
